(
    function (skyward, $, undefined)
    {
        skyward.infobutton = skyward.infobutton || {};

        var performBuildInformationPopup = function (event)
        {
            var button = $(this);
            var data = button.data();

            var popupHeader = data.headerLabel ? data.headerLabel : 'More Information';
            var url = skyward.global.virtualDir + data.area + "/" + data.controller + "/" + data.action;

            if (data.id)
            {
                url += "/" + data.id;
            }
            $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    success: function (response)
                    {
                        var options =
                        {
                            id: 'InformationPopup',
                            anchorTo: button
                        };

                        skyward.modalLayer.showInformationDialog(popupHeader, response.contents.Content, null, options);
                        event.stopPropagation();
                    }
                });
        };

        var performBuildInformationPopupNoServer = function ()
        {
            var button = $(this);
            var data = button.data();
            var options =
            {
                additionalClasses: 'informationPopup',
                anchorTo: button
            };

            var returnMessage = "";

            if (data.message !== "")
            {
                $.each(data.message, function (index)
                {
                    var message = data.message[index];
                    if (message.Key !== null && message.Key !== undefined && message.Key !== '')
                    {
                        returnMessage += '<div class="informationPopupMessageContainer"><div><label class="infoPopupTitle infoPopupText">' + message.Key + ':</label></div><div><label class="infoPopupText"> ' + message.Value + '\n\n</label></div></div>';
                    }
                    else
                    {
                        returnMessage += '<div class="informationPopupMessageContainer"><div><label class="infoPopupText"> ' + message.Value + '\n\n</label></div></div>';
                    }
                });
            }

            skyward.modalLayer.showInformationDialog(data.headerLabel, returnMessage, null, options);
            event.stopPropagation();
        };
        
        var events =
        {
            'performBuildInformationPopup': performBuildInformationPopup,
            'performBuildInformationPopupNoServer': performBuildInformationPopupNoServer
        };

        //Bootstrap
        skyward.events.registerEvents('infobutton', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);